module.exports = __webpack_public_path__ + "static/media/vc.acad1e9d.svg";